import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines clsx (conditional classes) with tailwind-merge (resolves conflicting Tailwind classes).
 *
 * Usage:
 *   cn('px-4 py-2', isActive && 'bg-blue-500', className)
 *
 * This is the standard utility used by shadcn/ui components.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
